import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : parts for help system
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Segment, Label, Menu, Header } from 'semantic-ui-react';
// ---Framework imports
import { mapItems } from 'ldash';
import { Actions, Sel } from 'uix/registries';
import { funcPart, StandalonePart } from 'uix/parts';
import { useSelector, useState, useApi, useActions, useEffect } from 'uix/hooks';
import log from 'uix/logging';
import { ResizableDialog, XMenu } from 'uix/components';
import { WikiPane } from 'uix/wiki/render';
import { AclFeature } from 'uix/auth/components';
// ---Local imports
import S from './help.css';
// ---Globals
const HelpWiki = ({ wikiident })=>{
    let navigateHelp = useActions(Actions.navigateHelp);
    let request = useSelector(Sel.request);
    let mainIdent = `help/${request.classname}_${request.tabname}`;
    let navIdent = useSelector((root)=>root.meta.contextHelp.navigation[mainIdent]);
    let identifier = wikiident || navIdent || mainIdent;
    let preview = useSelector((root)=>root.data.wiki.preview[`WikiEditorDialog_${identifier}`]);
    let [dlgOpen, setDlgOpen] = useState(false);
    // always refresh data on dlg-open-state change
    let { data, error } = useApi('filter/getWikiRendered', {
        ident: identifier
    }, {
        deps: dlgOpen,
        autoreset: false
    });
    let rendered = preview?.rendered || data?.wiki.rendered;
    let editor = null;
    if (dlgOpen) {
        editor = /*#__PURE__*/ _jsx(ResizableDialog, {
            name: "WikiEdit",
            onClose: ()=>setDlgOpen(false),
            children: /*#__PURE__*/ _jsx(StandalonePart, {
                type: "WikiEditor",
                name: "WikiEditorDialog",
                storeKey: identifier,
                params: {
                    identifier
                }
            })
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: S.help,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: S.topMenu,
                children: /*#__PURE__*/ _jsxs(XMenu, {
                    children: [
                        /*#__PURE__*/ _jsxs(AclFeature, {
                            acl: "g:admin",
                            children: [
                                editor,
                                /*#__PURE__*/ _jsx(Menu.Item, {
                                    icon: "edit",
                                    active: dlgOpen,
                                    onClick: ()=>setDlgOpen(!dlgOpen)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Menu.Item, {
                            icon: "home",
                            disabled: !navIdent,
                            onClick: ()=>navigateHelp(mainIdent, null)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "wikiblock",
                style: {
                    padding: '0.6rem'
                },
                children: /*#__PURE__*/ _jsx(Segment, {
                    secondary: true,
                    children: /*#__PURE__*/ _jsx(WikiPane, {
                        rendered: rendered,
                        identifier: identifier
                    })
                })
            })
        ]
    });
};
const PartList = ({})=>{
    let measureParts = useActions(Actions.measureParts);
    useEffect(()=>{
        measureParts('contextHelp');
    }, []);
    let partMeasurements = useSelector((root)=>root.debug.partMeasurements['contextHelp']);
    let parts = mapItems(partMeasurements, (name, xx)=>{
        return /*#__PURE__*/ _jsx("div", {
            children: name
        }, name);
    });
    return /*#__PURE__*/ _jsx("div", {
        children: parts
    });
};
// Fake Help Area
export const ContextHelp = ({ ...props })=>{
    return /*#__PURE__*/ _jsx(HelpWiki, {
        ...props
    });
};
